import Big from 'big.js'
import Moment from 'moment'

/**
 * 日期格式化
 */
export function formatDate(date, fmt = 'YYYY/MM/DD HH:mm') {
  if (!date) {
    return null
  }

  return Moment(date).format(fmt)
}

/**
 * 价格格式化
 * @param  {Number} price 以分为单位的价格
 * @return {String}       +/-￥XX.XX (例如：+￥100.02)
 */
export function formatPrice(price, addPlus = true, priceSymbol = '￥') {
  if (isNaN(Number(price))) {
    return price
  }

  let isMinus = false
  if (price < 0) {
    isMinus = true
  }

  const resultList = String(Math.abs(price)).split('')
  if (resultList.length < 3) {
    const padZeros = '0'.repeat(3 - resultList.length).split('')
    resultList.unshift(...padZeros)
  }

  resultList.splice(-2, 0, '.')
  resultList.unshift(priceSymbol)

  if (isMinus) {
    resultList.unshift('-')
  } else if (!isMinus && Math.abs(price) && addPlus) {
    resultList.unshift('+')
  }

  return resultList.join('')
}

/**
 * 时长格式化: 转换到小时
 * @param  {Numer} time 用秒表示的时长
 * @param  {Number}} minuteType 分钟显示格式。0-不显示分钟；1-正常分钟格式；2-小数形式显示分钟
 * @return {String}     X天X小时X分钟
 */
export function formatTimeToHours(timeSec = 0, minuteType = 0) {
  let timeStr = ''

  const hours = Math.floor(timeSec / 3600)
  if (hours) {
    timeStr += `${hours}小时`
  }

  let minutes = Math.ceil((timeSec % 3600) / 60)
  if (!timeStr || minutes) {
    minutes = `${minutes === 60 ? 59 : minutes}分钟`
    if (minuteType === 0) {
      timeStr = timeStr ? `${timeStr}+` : minutes
    } else if (minuteType === 1) {
      timeStr += minutes
    } else if (minuteType === 2) {
      const decimal = (timeSec / 3600).toFixed(1)
      timeStr = `${Number(decimal)}小时`
    }
  }

  return timeStr
}

/**
 * 将分转化为元
 * @param {string | number} cent 单位为分的数量
 * @param {boolean} isReverse 是否从元转换为分
 */
export function formatCent(cent, isReverse) {
  cent = +cent
  if (Number.isNaN(cent)) {
    return 0
  }

  if (isReverse) {
    return Big(cent)
      .times(100)
      .toNumber()
  }

  return Big(cent)
    .div(100)
    .toNumber()
}
